<template>
    <div>
        <slot :closeAllDialog="closeAllDialog" :openTicketsDialog="openTicketsDialog" :openSubscribeDialog="openSubscribeDialog" :openPriceDialog="openPriceDialog"></slot>
    </div>
</template>

<script>
import { defineComponent, onMounted, ref } from 'vue';

export default defineComponent({
    name: 'EventHeader',
    props: {
        event: {
            type: Object,
            required: true,
        },
        openticketsdialog: {
            type: Function,
            required: true,
        },
        opensubscribedialog: {
            type: Function,
            required: true,
        },
        openpricedialog: {
            type: Function,
            required: true,
        }
    },
    setup(props) {
        const ticketsDialog = ref(null);
        const subscribeDialog = ref(null);
        const priceDialog = ref(null);

        const closeAllDialog = (() => {
            const closePrice = document.getElementById('price-popup');
            const closeSubscribe = document.getElementById('subscribe-popup');
            const closeTickets = document.getElementById('book-tickets-popup');

            if (closePrice) closePrice.close();
            if (closeSubscribe) closeSubscribe.close();
            if (closeTickets) closeTickets.close();
        });

        const openTicketsDialog = (() => {
            closeAllDialog();
            ticketsDialog.value.showModal();
            props.openticketsdialog(props.event);
        });

        const openSubscribeDialog = (() => {
            closeAllDialog();
            subscribeDialog.value.showModal();
            props.opensubscribedialog(props.event);
        });

        const openPriceDialog = (() => {
            closeAllDialog();
            priceDialog.value.showModal();
            props.openpricedialog(props.event);
        });

        onMounted(() => {
            ticketsDialog.value = document.getElementById('book-tickets-popup');
            subscribeDialog.value = document.getElementById('subscribe-popup');
            priceDialog.value = document.getElementById('price-popup');
        })

        return {
            openTicketsDialog,
            openSubscribeDialog,
            openPriceDialog,
            closeAllDialog
        };
    },
});
</script>
